export const COOKIE_NAME = "mypa_session";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

// ============================================================================
// APPLICATION IDENTITY
// ============================================================================

export const APP_TITLE = "MyPA - Carbon Accounting";
export const APP_LOGO = "/mypa-logo.webp";
export const APP_DESCRIPTION = "Plateforme de comptabilité carbone pour PME africaines";

// ============================================================================
// BRAND COLORS (from mypa.earth)
// ============================================================================

export const BRAND_COLORS = {
  navy: "#1e3a5f",
  emerald: "#4a9d7e",
  lightBlue: "#a5b4fc",
  lightGreen: "#86efac",
  lightGray: "#f3f4f6",
  darkGray: "#1f2937",
  mediumGray: "#6b7280",
  success: "#10b981",
  warning: "#f59e0b",
  error: "#ef4444",
} as const;

// ============================================================================
// AUTHENTICATION
// ============================================================================

export function getLoginUrl(redirectTo?: string): string {
  const base = import.meta.env.VITE_OAUTH_PORTAL_URL;
  const appId = import.meta.env.VITE_APP_ID;
  
  if (!base || !appId) {
    console.error("Missing OAuth configuration");
    return "/";
  }
  
  const params = new URLSearchParams({
    app_id: appId,
    redirect_uri: window.location.origin + "/api/oauth/callback",
  });
  
  if (redirectTo) {
    params.set("state", redirectTo);
  }
  
  return `${base}/oauth/authorize?${params.toString()}`;
}

// ============================================================================
// ROLES
// ============================================================================

export const USER_ROLES = {
  CLIENT: "client_user",
  DATA_ADMIN: "mypa_data_admin",
  SUPER_ADMIN: "mypa_super_admin",
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

// ============================================================================
// LANGUAGES
// ============================================================================

export const LANGUAGES = {
  EN: "en",
  FR: "fr",
  AR: "ar",
} as const;

export type Language = typeof LANGUAGES[keyof typeof LANGUAGES];

export const LANGUAGE_LABELS = {
  [LANGUAGES.EN]: "English",
  [LANGUAGES.FR]: "Français",
  [LANGUAGES.AR]: "العربية",
} as const;

// ============================================================================
// PERIOD TYPES
// ============================================================================

export const PERIOD_TYPES = {
  MONTH: "month",
  QUARTER: "quarter",
  YEAR: "year",
} as const;

export type PeriodType = typeof PERIOD_TYPES[keyof typeof PERIOD_TYPES];

export const PERIOD_STATUS = {
  DRAFT: "draft",
  OPEN: "open",
  CLOSED: "closed",
} as const;

export type PeriodStatus = typeof PERIOD_STATUS[keyof typeof PERIOD_STATUS];

// ============================================================================
// ROUTES
// ============================================================================

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  PROFILE: "/profile",
  PROFILE_COMPLETE: "/profile/complete",
  DASHBOARD: "/dashboard",
  PERIODS: "/periods",
  CALCULATOR: "/calculator",
  BENCHMARKS: "/benchmarks",
  LEARN: "/learn",
  ADMIN: "/admin",
} as const;
